import { Button } from "@/components/ui";
import { SidebarIcon } from "lucide-react";
import { useSidebar } from "./Sidebar";

export const FloatingSidebarToggleButton = () => {
  const { toggleSidebar } = useSidebar();
  return (
    <div className="sticky top-[calc(100%-58px)] left-2 h-full shadow-lg md:hidden">
      <Button
        variant="outline"
        className="absolute block h-[50px] w-[50px] rounded-full"
        onClick={toggleSidebar}
      >
        <SidebarIcon />
      </Button>
    </div>
  );
};
